<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>

        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <el-select
          v-model="period"
          @change="periodChange('main')"
          style="width: 30%; float: right; padding: 0"
        >
          <el-option
            v-for="item in periodOpthions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <hr />
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view"
          :option="option"
          @click="onClick"
        />
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold">{{ displayTitle }}</span>
          </el-row>
          <el-row>
            <el-select
              v-model="period"
              @change="periodChange('popup')"
              style="width: 30%; padding: 0; float: right"
            >
              <el-option
                v-for="item in periodOpthions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @click="onClick"
        />
      </el-dialog>
    </div>
  </el-col>
</template>
 
<script>
import api from "@/api";
var moment = require("moment-timezone");
export default {
  name: "TelephoneAnswerChart",
  props: ["title", "displayTitle"],
  data() {
    return {
      periodOpthions: [
        {
          value: "①過去3ヶ月間の同月比",
          label: "①過去3ヶ月間の同月比",
        },
        {
          value: "②過去12ヶ月間の同月比",
          label: "②過去12ヶ月間の同月比",
        },
        {
          value: "③過去3年間の同月比",
          label: "③過去3年間の同月比",
        },
        {
          value: "④過去3年間の同年比",
          label: "④過去3年間の同年比",
        },
      ],
      period: "②過去12ヶ月間の同月比",
      endDate: this.$root.endDate,
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
    };
  },
  created() {
    let self = this;
    self.loading = true;
    api.getTelephoneAnswerCount("ja-JP_Telephony",self.period,self.endDate, self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
        (res) => {
          let data = res.data;
          let month_list = data.month_list;
          let data_list = data.output_list;
          self.option = {
            color: ["#A0522D", "#FFC107"],
            title: {
              // subtext: "件",
            },
            tooltip: {
              trigger: "axis",
            },
            toolbox: {
              show: true,
            },
            calculable: true,
            xAxis: [
              {
                type: "category",
                data: month_list,
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "件",
              },
            ],
            series: data_list,
          };
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.endDate = endDate;
      this.periodChange("main");
    });
  },
  methods: {
    showPopUp() {
      this.popUpDisplay = true;
    },
    onClick(params) {
      let startDate = "";
      let endDate = "";
      if (params.name.length > 8) {
        startDate = moment(
          params.name.split("~")[0].replace("年", "-").replace("月", "")
        )
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = moment(
          params.name.split("~")[1].replace("年", "-").replace("月", "")
        )
          .endOf("month")
          .format("YYYY-MM-DD");
      } else if (params.name.length < 8) {
        let baseEndDate = this.endDate.substring(5, 7);
        if (Number(params.name.replace("月", "")) <= Number(baseEndDate)) {
          startDate = moment(
            this.endDate.substring(0, 4) + "-" + params.name.replace("月", "")
          )
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(
            this.endDate.substring(0, 4) + "-" + params.name.replace("月", "")
          )
            .endOf("month")
            .format("YYYY-MM-DD");
        } else {
          let baseYear = Number(this.endDate.substring(0, 4)) - 1;
          startDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .endOf("month")
            .format("YYYY-MM-DD");
        }
      } else {
        startDate = moment(params.name.replace("年", "-").replace("月", ""))
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = moment(params.name.replace("年", "-").replace("月", ""))
          .endOf("month")
          .format("YYYY-MM-DD");
      }

      let ageAndSexStr = '';
      if (this.$root.ageForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
      }
      if (this.$root.sexForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
      }
      if (params.seriesName == "全体") {
        window.open(
          this.$root.redmineUrl +
            "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
            startDate +
            "&v%5Bcreated_on%5D%5B%5D=" +
            endDate +
            "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=cf_80&op%5Bcf_80%5D=*&f%5B%5D=cf_85&op%5Bcf_85%5D=%3D&v%5Bcf_85%5D%5B%5D=ja-JP_Telephony&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
            + ageAndSexStr
        );
      } else {
        window.open(
          this.$root.redmineUrl +
            "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
            startDate +
            "&v%5Bcreated_on%5D%5B%5D=" +
            endDate +
            "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=cf_80&op%5Bcf_80%5D=%3D&v%5Bcf_80%5D%5B%5D=0&f%5B%5D=cf_85&op%5Bcf_85%5D=%3D&v%5Bcf_85%5D%5B%5D=ja-JP_Telephony&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
            + ageAndSexStr
        );
      }
    },
    periodChange(value) {
      let self = this;
      if (value == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }

      api.getTelephoneAnswerCount("ja-JP_Telephony",self.period,self.endDate,self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
          (res) => {
            let data = res.data;
            let month_list = data.month_list;
            let data_list = data.output_list;
            self.option = {
              color: ["#A0522D", "#FFC107"],
              title: {
                // subtext: "件",
              },
              tooltip: {
                trigger: "axis",
              },
              toolbox: {
                show: true,
              },
              calculable: true,
              xAxis: [
                {
                  type: "category",
                  data: month_list,
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "件",
                },
              ],
              series: data_list,
            };
            if (value == "main") {
              self.loading = false;
            } else {
              self.popupLoading = false;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    },
  },
};
</script>
<style>
</style>
